export const filelist = [
    {
        value: "1 Sessionseinladung",
        link: "/protocols/20250523/1_Sessionseinladung.pdf"
    },
    {
        value: "2 Beilagenblatt",
        link: "/protocols/20250523/2_Beilagenblatt.pdf"
    },
    {
        value: "3 Rechenschaftsbericht 2024",
        link: "/protocols/20250523/3_Rechenschaftsbericht_2024.pdf"
    },
    {
        value: "4 GPK-Antrag",
        link: "/protocols/20250523/4_GPK-Antrag.pdf"
    },
    {
        value: "5 Nachkredit 2024",
        link: "/protocols/20250523/5_Nachkredit_2024.pdf"
    },
    {
        value: "6 Strategie Kantonalkirche - Bericht",
        link: "/protocols/20250523/6_Strategie_Kantonalkirche_-_Bericht.pdf"
    },
    {
        value: "7 Strategie Kantonalkirche - Vernehmlassungsergebnis",
        link: "/protocols/20250523/7_Strategie_Kantonalkirche_-_Vernehmlassungsergebnis.pdf"
    },
    {
        value: "8 Strategie Kantonalkirche - Entwurf",
        link: "/protocols/20250523/8_Strategie_Kantonalkirche_-_Entwurf.pdf"
    },
    {
        value: "9 Mitfinanzierung Spitalseelsorge",
        link: "/protocols/20250523/9_Mitfinanzierung_Spitalseelsorge.pdf"
    },
    {
        value: "10 Beantwortung Motion Betriebsfinanzierung Diakonie",
        link: "/protocols/20250523/10_Beantwortung_Motion_Betriebsfinanzierung_Diakonie.pdf"
    },
]